import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { debounceTime, distinctUntilChanged, switchMap } from "rxjs/operators";
import { Subject, EMPTY } from "rxjs";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { Address } from "../../../../core/models/shared/address";
import { City } from "../../../../core/models/shared/cityList";
import { AddressCountryRegion } from "../../../../core/models/shared/countryRegionList";
import { AddressCounty } from "../../../../core/models/shared/countyList";
import { District } from "../../../../core/models/shared/districtList";
import { ExchangeRatesDto } from "../../../../core/models/shared/exchangeRateDto";
import { AddressState } from "../../../../core/models/shared/stateList";
import { GetVendorSearchResponseDto } from "../../../../core/models/vendor/getVendorSearchResponseDto";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ShipToAddressComponent } from "../../../../shared/components/ship-to-address/ship-to-address.component";
import { ClientSearchList } from "../../../../core/models/shared/clientSearchList";
import { CommonModule } from "@angular/common";
import { GetAllVendorsDto } from "../../../../core/models/vendor/getAllVendors";
import { QuotesHeader } from "../../../../core/models/qoutes/quotesHeader";
interface ShipToAddress {
  countryRegionIdD365: string | null;
  cityD365: string | null;
  stateD365: string | null;
}

interface AddressFormData {
  shipTo: ShipToAddress;
}
@UntilDestroy()
@Component({
  selector: "jni-line-ship-to",
  templateUrl: "./line-ship-to.component.html",
  styleUrls: ["./line-ship-to.component.scss"],
  imports: [CommonModule, ShipToAddressComponent, ReactiveFormsModule],
})
export class LineShipToComponent implements OnInit {
  @Input() parent!: FormGroup;
  @Input() deliveryAddress: {
    id: number;
    name: string;
    status: boolean;
  }[] = [];
  @Input() countryRegionList: AddressCountryRegion[] = [];
  @Input() vendroAddressBookObject!: GetAllVendorsDto;
  @Input() addressObject!: Address;
  @Input() headerObject!: QuotesHeader;
  @Input() customerList: Address[] = [];
  @Input() showAddress = false;
  @Input() formErrors!: Record<string, string>;
  @Output() validationErrorEvent = new EventEmitter();

  currencyObject?: ExchangeRatesDto;
  currencyConversion?: ExchangeRatesDto;

  showZip = true;
  showDistrict = false;
  showPostBox = false;
  showCity = false;
  showCounty = false;
  showState = false;
  showStreetNumber = false;
  showStreet = true;
  showbuildingComplement = false;
  showAddressBook = false;
  showAppartment = false;
  showAddressValidation = false;
  showValidateAddress = false;
  showForeignCurrency = false;
  shipToAddress = false;
  vendorAccountAndBook = false;
  firmOneCheckBox = false;

  vendorList: GetVendorSearchResponseDto[] = [];
  clientLists: ClientSearchList[] = [];
  //addressBookList: any[] = [];
  shiftToAddressList!: Address[];
  //vendorAccountSearchList: any;

  shiftToAddressField = "";
  selectedAccountNumber = "";
  vendorAccountSeletion = "";
  addressBookName = "";
  isAddressValidationButton = true;

  showSmallLoader = false;
  countryRegionSelectedId = "";

  //getFilteredZipCode: any[] = [];
  //getZipCode: any[] = [];
  cityList: City[] = [];
  stateSelectedId = "";
  stateList: AddressState[] = [];
  districtList: District[] = [];
  countyList: AddressCounty[] = [];
  addressValidationStatus = true;
  public searchVendor$ = new Subject<string>();

  @ViewChild("shipTo", { static: false })
  shipTo!: ShipToAddressComponent;

  constructor(private _samplepoListingService: SamplepoListingService) {}

  ngOnInit(): void {
    this.searchVendorName();

    this.parent.valueChanges.subscribe(data => {
      this.addressValidation(data);
    });
  }

  clearShipToAddressForm() {
    this.shiftToAddressField = "";
    this.countryRegionSelectedId = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  addressValidation(data: AddressFormData) {
    const addressObj = data.shipTo;
    if (
      addressObj.countryRegionIdD365 != "" &&
      addressObj.countryRegionIdD365 != null &&
      addressObj.cityD365 != "" &&
      addressObj.cityD365 != null &&
      addressObj.stateD365 != "" &&
      addressObj.stateD365 != null
    ) {
      this.isAddressValidationButton = false;
      this.parent
        .get(["shipTo", "addressD365"])
        ?.setValidators(Validators.required);
    } else {
      this.isAddressValidationButton = true;
    }
  }

  showAddressFieldLineSelection(addressSelectionName: string) {
    // if (
    //   addressSelectionName == 'To Vendor' ||
    //   addressSelectionName === 'To vendor'
    // ) {
    //   this.shipToAddress = false;
    //   this.vendorAccountAndBook = true;
    // } else if (
    //   addressSelectionName === 'Client address book' ||
    //   addressSelectionName === 'Client address book' ||
    //   addressSelectionName == 'Address book' ||
    //   addressSelectionName == 'To address book'
    // ) {
    //   this.shipToAddress = true;
    //   this.vendorAccountAndBook = false;
    // }
    if (addressSelectionName.toLowerCase() === "to vendor") {
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
    } else if (
      addressSelectionName.toLowerCase() === "client address book" ||
      addressSelectionName.toLowerCase() == "address book" ||
      addressSelectionName.toLowerCase() == "to address book"
    ) {
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
    }
  }

  // enableDeliveryName() {
  //   this.parent.get(['shipTo', 'deliveryNameD365'])?.enable();
  // }

  disableDeliveryName() {
    this.parent.get(["shipTo", "deliveryNameD365"])?.disable();
  }

  patchValueInMultiShipToAndTbd(event: string) {
    this.patchFormDeliveryAddress("", event);
  }

  patchValueInCustomerShipToName(descriptionD365: string) {
    this.shipTo.shiftToAddressField = descriptionD365;
  }

  patchFormDeliveryAddress(
    addressSelectionName: string,
    headerAddressSelection: string
  ) {
    if (addressSelectionName) {
      addressSelectionName =
        addressSelectionName === "To header ship to" ||
        addressSelectionName == "To header ship to" ||
        addressSelectionName == "To header ship-to"
          ? "To Header Ship To"
          : addressSelectionName;
      this.parent.patchValue({
        shipTo: {
          addressSelectionName: addressSelectionName,
        },
      });
    }
    if (addressSelectionName?.toLowerCase()?.includes("header")) {
      this.disabledAttentionandLocationField();
    }
    if (
      headerAddressSelection &&
      (headerAddressSelection?.toLowerCase()?.includes("multi") ||
        headerAddressSelection?.toLowerCase()?.includes("drop") ||
        headerAddressSelection?.toLowerCase()?.includes("tbd"))
    ) {
      const headerAddressSelectionName = headerAddressSelection;
      this.parent.patchValue({
        shipTo: {
          addressD365: headerAddressSelectionName,
        },
      });
    }
  }

  onDeliveryAddressChange(event: string) {
    this.shipTo.showName = true;
    if (
      event === "Client address book" ||
      event === "Client Address Book" ||
      event == "Address book" ||
      event == "To address book"
    ) {
      this.shipTo.showName = false;
      this.shipToAddress = true;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.patchAddressOfVendorAddressBook();
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
    } else if (event === "To vendor" || event == "To Vendor") {
      this.shipTo.showName = false;
      this.shipToAddress = false;
      this.vendorAccountAndBook = true;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.clearShifToForm();
    } else if (
      event === "To header ship to" ||
      event == "To header ship to" ||
      event == "To header ship-to"
    ) {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = false;
      this.showValidateAddress = false;
      this.showAddress = true;
      if (this.addressObject) {
        this.patchFormInHeaderToShip(this.addressObject);
      }
      if (this.headerObject) {
        this.patchFormInHeaderToShipAddress(this.headerObject);
      }
      this.clearValidationOnAddress();
      this.hiddenAddressFields();
      this.disableDeliveryName();
    } else {
      this.shipToAddress = false;
      this.vendorAccountAndBook = false;
      this.showAddressValidation = true;
      this.showValidateAddress = true;
      this.showAddress = false;
      this.applyValidationOnAddress();
      if (event !== "One time") {
        this.clearShifToForm();
      }
      if (event === "One time") {
        this.clearValidationOnAddress();
      }
    }
    this.enableCountryField(event);
  }

  patchFormInHeaderToShip(address: Address) {
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: address.countryRegionIdD365,
        zipCodeD365: address.zipCodeD365,
        streetD365: address.streetD365,
        cityD365: address.cityD365,
        stateD365: address.stateD365,
        countyD365: address.countyD365,
        streetNumberD365: address.streetNumberD365,
        buildingComplimentD365: address.buildingComplimentD365,
        apartment_RUD365:
          address.apartment_RUD365 === null ? "" : address.apartment_RUD365,
        postBoxD365: address.postBoxD365,
        districtNameD365: address.districtNameD365,
        addressLocationNumber:
          address.locationNumberD365 != null &&
          !(address.locationNumberD365.length > 30) &&
          parseInt(address.locationNumberD365)
            ? address.locationNumberD365
            : 0,
        addressD365: address.addressD365?.replace("<br/>", "\n"),
      },
    });
  }

  patchFormInHeaderToShipAddress(header: QuotesHeader) {
    this.parent.patchValue({
      shipTo: {
        attentionInformationD365: header.attentionInformationD365,
        locationD365: header.locationD365 ?? "",
        rSMJNIShipToEmailD365: header.rsmjniShipToEmail ?? "",
        deliveryNameD365: header.deliveryNameD365,
        //addressLocationNumber: header.addressLocationNumberD365
      },
    });
    this.shipTo.showName = true;
    this.disableDeliveryName();
  }

  enableCountryField(event: string) {
    if (event === "One time" || event === "One time blank") {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.enable();
      this.parent.get(["shipTo", "streetD365"])?.enable();
    } else {
      this.parent.get(["shipTo", "countryRegionIdD365"])?.disable();
      this.parent.get(["shipTo", "streetD365"])?.disable();
    }
  }

  disabledAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.disable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.disable();
    this.parent.get(["shipTo", "locationD365"])?.disable();
    this.parent.get(["shipTo", "addressD365"])?.disable();
  }

  enableAttentionandLocationField() {
    this.parent.get(["shipTo", "attentionInformationD365"])?.enable();
    this.parent.get(["shipTo", "rSMJNIShipToEmailD365"])?.enable();
    this.parent.get(["shipTo", "locationD365"])?.enable();
  }

  applyValidationOnAddress() {
    this.parent
      .get(["shipTo", "addressD365"])
      ?.setValidators(Validators.required);
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  hiddenAddressFields() {
    this.showDistrict = false;
    this.showPostBox = false;
    this.showCity = false;
    this.showCounty = false;
    this.showState = false;
    this.showStreetNumber = false;
    this.showbuildingComplement = false;
    this.showAddressBook = false;
    this.showAppartment = false;
  }

  patchAddressOfVendorAddressBook() {
    this.showSmallLoader = true;
    if (
      this.vendroAddressBookObject?.partyNumber != undefined ||
      this.vendroAddressBookObject?.vendorAccountNumber != undefined
    ) {
      this._samplepoListingService
        .getVendorAddressByPartyNumber(
          this.vendroAddressBookObject?.partyNumber,
          this.vendroAddressBookObject?.vendorAccountNumber
        )
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            this.showSmallLoader = false;
            if (res.data != null) {
              this.shiftToAddressList = res.data;
            }
          },
          error: () => {
            this.showSmallLoader = false;
          },
        });
    }
  }

  clearValidationOnAddress() {
    this.parent.get(["shipTo", "addressD365"])?.clearValidators();
    this.parent.get(["shipTo", "addressD365"])?.updateValueAndValidity();
  }

  // onshipToAddressFilter(event: any, drop: any) {
  //   drop.open();
  // }

  // onShitToAddressSeletion(event: any, shipAddressToggle: any) {
  //   shipAddressToggle.close();
  //   if (event.descriptionD365 != '') {
  //     this.shiftToAddressField = event.descriptionD365;
  //   }
  //   this.patchFormInShipToAddressField(event);
  //   if (this.headerObject) {
  //     this.patchFormInHeaderToShipAddress(this.headerObject);
  //   }
  // }

  // patchFormInShipToAddressField(address: Address) {
  //   this.parent.patchValue({
  //     shipTo: {
  //       countryRegionIdD365: address.countryRegionIdD365,
  //       zipCodeD365: address.zipCodeD365,
  //       streetD365: address.streetD365,
  //       cityD365: address.cityD365,
  //       stateD365: address.stateD365,
  //       countyD365: address.countyD365,
  //       streetNumberD365: address.streetNumberD365,
  //       buildingComplimentD365: address.buildingComplimentD365,
  //       apartment_RUD365:
  //         address.apartment_RUD365 === null ? '' : address.apartment_RUD365,
  //       postBoxD365: address.postBoxD365,
  //       districtNameD365: address.districtNameD365,
  //       addressLocationNumber:
  //         address.locationNumberD365 === null
  //           ? 0
  //           : parseInt(address.locationNumberD365 || '0'),
  //       addressD365: address.addressD365?.replace('<br/>', '\n')
  //     }
  //   });
  // }

  getVendorByName(accountNumberOrName: string) {
    this._samplepoListingService
      .getVendorByNameAndAccountNumberFilter(accountNumberOrName)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            //this.getVendorAddress(res.data[0].partyNumber ?? '');
            this.shipTo.vendorAccountSeletion = res?.data[0]?.vendorName;
            this.shipTo.addressBookName = res?.data[0]?.vendorName;
          }
        },
      });
  }

  // getVendorAddress(partyNumber: string) {
  //   this._samplepoListingService
  //     .getVendorAddressByPartyNumber(partyNumber)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         if (res.data) {
  //           this.addressBookList = res.data;
  //         }
  //       }
  //     });
  // }

  searchVendorName() {
    this.searchVendor$
      .pipe(
        debounceTime(1000),
        distinctUntilChanged(),
        switchMap((searchitem: string) => {
          this.showSmallLoader = true;
          const accountNumberOrName = searchitem;
          this.vendorList = [];
          if (accountNumberOrName != "" && accountNumberOrName != undefined) {
            return this._samplepoListingService.getVendorByNameAndAccountNumberFilter(
              accountNumberOrName
            );
          }
          return EMPTY;
        })
      )
      .subscribe({
        next: res => {
          if (res.data != null) {
            this.vendorList = res.data;
          }
          this.showSmallLoader = false;
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  // onVendorSearchOpenToggle(mydrop: any) {
  //   mydrop.open();
  // }

  // onVendorAccountSelection(
  //   event: any,
  //   vendorAccount: any,
  //   vendoraddressbookModel: any
  // ) {
  //   this.clearShifToForm();
  //   this.vendorAccountSeletion = event.vendorName;
  //   const partyNumber = event.partyNumber;
  //   if (
  //     this.vendorAccountSeletion != undefined &&
  //     this.vendorAccountSeletion != ''
  //   ) {
  //     this._samplepoListingService
  //       .getVendorAddressByPartyNumber(partyNumber)
  //       .pipe(untilDestroyed(this))
  //       .subscribe({
  //         next: (res: any) => {
  //           if (res.data != null) {
  //             this.addressBookList = res.data;
  //             this.patchValueInVendorAccount(
  //               event.vendorAccountNumber,
  //               this.vendorAccountSeletion
  //             );
  //             if (this.addressBookList.length === 1) {
  //               this.onVendorAddressBookSelection(this.addressBookList[0], '');
  //             }
  //             if (this.addressBookList?.length > 1) {
  //               vendoraddressbookModel.open();
  //             } else {
  //               vendoraddressbookModel.close();
  //             }
  //           }
  //         }
  //       });
  //   }
  //   vendorAccount.close();
  // }

  // patchValueInVendorAccount(vendorAccount: string, vendorName: string) {
  //   this.parent.patchValue({
  //     shipTo: {
  //       shipToVendorAccountD365: vendorAccount,
  //       shipToVendorAccountNameD365: vendorName
  //     }
  //   });
  // }

  clearShifToForm() {
    this.parent.patchValue({
      shipTo: {
        countryRegionIdD365: "",
        zipCodeD365: "",
        streetD365: "",
        cityD365: "",
        stateD365: "",
        addressD365: "",
        rSMJNIShipToEmailD365: "",
        addressBook: "",
        buildingComplimentD365: "",
        apartment_RUD365: "",
        postBoxD365: "",
        countyD365: "",
        streetNumberD365: "",
        districtNameD365: "",
      },
    });

    this.shiftToAddressField = "";
    this.vendorAccountSeletion = "";
    this.addressBookName = "";
  }

  // onVendorAddressBookSelection(event: any, vendorAddressBookToggle: any) {
  //   this.addressBookName = event.descriptionD365;
  //   this.parent.patchValue({
  //     shipTo: {
  //       countryRegionIdD365: event.countryRegionIdD365,
  //       zipCodeD365: event.zipCodeD365,
  //       streetD365: event.streetD365,
  //       cityD365: event.cityD365,
  //       stateD365: event.stateD365,
  //       countyD365: event.countyD365,
  //       streetNumberD365: event.streetNumberD365,
  //       buildingComplimentD365: event.buildingComplimentD365,
  //       apartment_RUD365:
  //         event.apartment_RUD365 === null ? '' : event.apartment_RUD365,
  //       postBoxD365: event.postBoxD365,
  //       districtNameD365: event.districtNameD365,
  //       addressLocationNumber: parseInt(event.locationNumberD365),
  //       addressD365: event.addressD365?.replace('<br/>', '\n')
  //     }
  //   });
  //   if (vendorAddressBookToggle) {
  //     vendorAddressBookToggle.close();
  //   }
  // }

  // onVendorAddressBookSelect(event: any) {
  //   if (this.addressBookList?.length > 1) {
  //     event.open();
  //   } else {
  //     event.close();
  //   }
  // }

  // onCountryRegionSelection(countryid: string) {
  //   if (countryid) {
  //     this.parent.get(['shipTo', 'zipCodeD365'])?.enable();
  //     this.parent.get(['shipTo', 'cityD365'])?.enable();
  //     this.parent.get(['shipTo', 'stateD365'])?.enable();
  //   } else {
  //     this.parent.get(['shipTo', 'zipCodeD365'])?.disable();
  //     this.parent.get(['shipTo', 'cityD365'])?.disable();
  //     this.parent.get(['shipTo', 'stateD365'])?.disable();
  //   }

  //   const countryregionid = countryid != null ? countryid : '';
  //   if (countryregionid == '') {
  //     this.cityList != null ? (this.cityList.length = 0) : null;
  //     this.stateList != null ? (this.stateList.length = 0) : null;
  //     this.addressValidationStatus = true;
  //     this.updateValueOnCountrySelection();
  //   } else {
  //     this.updateValueOnCountrySelection();
  //     this.filterAddressFormats(countryregionid);
  //     this.getCountyListData(countryregionid);
  //     this.getStateListData(countryregionid);
  //   }
  // }

  // filterAddressFormats(countryId: string) {
  //   const filteredRegions = this.countryRegionList.filter(
  //     (x) => x.countryRegionD365 == countryId
  //   );
  //   this.getAddressFormats(filteredRegions[0].addressFormatD365);
  // }

  // getAddressFormats(formatId: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getAddressFormatsByFormatId(formatId)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.filterAddressesUsingAddressFormats(res?.data?.descriptionD365);
  //         this.showSmallLoader = false;
  //       },
  //       error: (res) => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // filterAddressesUsingAddressFormats(description: string | null) {
  //   if (
  //     !description?.toLowerCase().includes('zip') &&
  //     !description?.toLowerCase().includes('postal_code') &&
  //     !description?.toLowerCase().includes('postcode') &&
  //     !description?.toLowerCase().includes('postal code')
  //   ) {
  //     this.showZip = false;
  //   } else {
  //     this.showZip = true;
  //   }
  //   if (!description?.toLowerCase().includes('district')) {
  //     this.showDistrict = false;
  //   } else {
  //     this.showDistrict = true;
  //   }
  //   if (!description?.toLowerCase().includes('city')) {
  //     this.showCity = false;
  //   } else {
  //     this.showCity = true;
  //   }
  //   if (!description?.toLowerCase().includes('county')) {
  //     this.showCounty = false;
  //   } else {
  //     this.showCounty = true;
  //   }
  //   if (
  //     !description?.toLowerCase().includes('state') &&
  //     !description?.toLowerCase().includes('province')
  //   ) {
  //     this.showState = false;
  //   } else {
  //     this.showState = true;
  //   }
  //   if (!description?.toLowerCase().includes('street')) {
  //     this.showStreet = false;
  //   } else {
  //     this.showStreet = true;
  //   }
  //   if (!description?.toLowerCase().includes('number')) {
  //     this.showStreetNumber = false;
  //   } else {
  //     this.showStreetNumber = true;
  //   }
  //   if (
  //     !description?.toLowerCase().includes('complement') &&
  //     !description?.toLowerCase().includes('building')
  //   ) {
  //     this.showbuildingComplement = false;
  //   } else {
  //     this.showbuildingComplement = true;
  //   }
  //   if (!description?.toLowerCase().includes('apartment')) {
  //     this.showAppartment = false;
  //   } else {
  //     this.showAppartment = true;
  //   }
  //   const poBox = description
  //     ?.toLowerCase()
  //     .split(',')
  //     .join(' ')
  //     .split('/')
  //     .join(' ')
  //     .split('_')
  //     .join(' ')
  //     .split(';')
  //     .join(' ')
  //     .split(' ')
  //     .some((x) => x == 'post' || x == 'postbox');
  //   if (!poBox) {
  //     this.showPostBox = false;
  //   } else {
  //     this.showPostBox = true;
  //   }
  // }

  // updateValueOnCountrySelection() {
  //   this.parent.patchValue({
  //     shipTo: {
  //       zipCodeD365: '',
  //       districtNameD365: '',
  //       cityD365: '',
  //       countyD365: '',
  //       stateD365: ''
  //     }
  //   });
  // }

  // getStateListData(id: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getStateList(id)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.stateList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: (res) => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // selectedZipCode(zipCode: any) {
  //   if (!zipCode) {
  //     return;
  //   }
  //   this._addNewClientService
  //     .getPostalCodeByZipCode(zipCode)
  //     .subscribe((res) => {
  //       this.showSmallLoader = true;
  //       if (!res.data) {
  //         this.showSmallLoader = false;
  //         return;
  //       }
  //       this._addNewClientService
  //         .getCityList(res.data.stateId, res.data.countryRegionId)
  //         .pipe(
  //           map((cityResponse) => {
  //             this.cityList = cityResponse.data;

  //             return cityResponse.data.filter(
  //               (city) =>
  //                 city.cityKeyD365?.includes(res?.data?.cityId) &&
  //                 city.countryRegionIdD365 == res?.data?.countryRegionId &&
  //                 city.countyIdD365 == res?.data?.countyId &&
  //                 city.stateIdD365 == res?.data?.stateId
  //             );
  //           })
  //         )
  //         .pipe(untilDestroyed(this))
  //         .subscribe({
  //           next: (response) => {
  //             this.parent.patchValue({
  //               shipTo: {
  //                 countyD365: response[0]?.countyIdD365,
  //                 cityD365: response[0]?.nameD365,
  //                 stateD365: response[0]?.stateIdD365,
  //                 streetD365: res?.data?.street,
  //                 addressLocationNumber: 0
  //               }
  //             });
  //             this.showSmallLoader = false;
  //           },
  //           error: (response) => {
  //             this.showSmallLoader = false;
  //           }
  //         });
  //     });
  // }

  // searchZipCode: OperatorFunction<string, readonly string[]> = (
  //   text$: Observable<string>
  // ) =>
  //   text$.pipe(
  //     debounceTime(200),
  //     distinctUntilChanged(),
  //     switchMap(async (term: string) =>
  //       term.length < 4
  //         ? []
  //         : (this.getFilteredZipCode = await this.getZipListData(
  //             this.countryRegionSelectedId,
  //             term
  //           ))
  //     )
  //   );

  // async getZipListData(id: string, name: string) {
  //   this.getFilteredZipCode = [];
  //   this.showSmallLoader = true;
  //   const res = await lastValueFrom(
  //     this._addNewClientService.getZipList(id, name).pipe(untilDestroyed(this))
  //   );
  //   this.getZipCode = res.data;
  //   this.showSmallLoader = false;
  //   return this.getZipCode;
  // }

  // onStateSelectionChange(stateid: string) {
  //   this.parent.patchValue({ shipTo: { cityD365: '' } });
  //   this.getCityListData(stateid, this.countryRegionSelectedId);
  // }

  // getCityListData(stateid: string, countryid: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getCityList(stateid, countryid)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.cityList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: (res) => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // async zipCodeSearchFilter(event: any) {
  //   this.selectedZipCode(event.value);
  // }

  // getCountyListData(id: string) {
  //   this.showSmallLoader = true;
  //   this._addNewClientService
  //     .getCountyList(id)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.countyList = res?.data;
  //         this.showSmallLoader = false;
  //       },
  //       error: (res) => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // validateAddress() {
  //   this.showSmallLoader = true;
  //   const address = 'usa ca street 1';
  //   this._addNewClientService
  //     .checkAddressValidation(address)
  //     .pipe(untilDestroyed(this))
  //     .subscribe({
  //       next: (res) => {
  //         this.showSmallLoader = false;
  //         if (res.data == true) {
  //           this.parent.get(['shipTo', 'addressD365'])?.clearValidators();
  //           this.parent
  //             .get(['shipTo', 'addressD365'])
  //             ?.updateValueAndValidity();
  //           this.addressValidationStatus = false;
  //         }
  //       },
  //       error: (res) => {
  //         this.showSmallLoader = false;
  //       }
  //     });
  // }

  // showAddressComponent() {
  //   const deliveryAddress = this.parent.get([
  //     'shipTo',
  //     'addressSelectionName'
  //   ])?.value;
  //   if (deliveryAddress && deliveryAddress.toLowerCase().includes('one')) {
  //     this.parent.get(['shipTo', 'addressD365'])?.enable();
  //     //this.showAddress = false;
  //     return true;
  //   } else {
  //     this.parent.get(['shipTo', 'addressD365'])?.disable();
  //     //this.showAddress = true;
  //     return false;
  //   }
  // }

  logValidationErrors() {
    this.validationErrorEvent.emit();
  }

  getLoaderStatus(status: boolean) {
    this.showSmallLoader = status;
  }
}
